export default __webpack_public_path__ + "static/media/get_paid.e59f2f9a.png";